import React from 'react';

/**
 * Pricing / billing plan bullet list (checks flush left; plus / video lines may indent).
 * @param {{
 *   features: Array<string | { text: string, icon?: 'check' | 'plus' | 'none' | 'storage' | 'users', indent?: boolean, bold?: boolean }>,
 *   (indent applies only when icon is 'plus'.)
 *   formatLine?: (text: string) => string
 * }} props
 */
export function PlanFeatureList({ features, formatLine }) {
  return (
    <ul className="plan-list">
      {features.map((feature, i) => {
        const item =
          typeof feature === 'object' && feature !== null && 'text' in feature
            ? feature
            : { text: String(feature), icon: 'check' };
        let text = item.text;
        if (formatLine) {
          text = formatLine(text, item);
        }
        const iconKind =
          item.icon === 'plus'
            ? 'plus'
            : item.icon === 'storage'
              ? 'storage'
              : item.icon === 'users'
                ? 'users'
                : item.icon === 'none'
                  ? 'none'
                  : 'check';
        const indent = !!item.indent && item.icon === 'plus';
        const bold = !!item.bold;
        return (
          <li
            key={i}
            className={
              [indent && 'plan-list-item-indent', iconKind === 'none' && 'plan-list-item--intro']
                .filter(Boolean)
                .join(' ') || undefined
            }
          >
            {iconKind !== 'none' && (
              <i
                className={`ph ${
                  iconKind === 'plus'
                    ? 'ph-plus'
                    : iconKind === 'storage'
                      ? 'ph-hard-drives'
                      : iconKind === 'users'
                        ? 'ph-users-three'
                        : 'ph-check-circle'
                } plan-icon`}
                aria-hidden="true"
              />
            )}
            {bold ? (
              <strong
                className={
                  iconKind === 'none'
                    ? 'plan-list-feature-bold plan-list-feature-intro'
                    : 'plan-list-feature-bold'
                }
              >
                {text}
              </strong>
            ) : (
              text
            )}
          </li>
        );
      })}
    </ul>
  );
}
